// utils.js
export const generateColors = (count) => {
  const baseColors = ['#1064bd', '#27a34a', '#562382', '#282beb', '#16f045', '#a554eb', '#f39c12', '#e74c3c'];
  // const baseColors = [
  //   "#0033a0",
  //   "#0047b3",
  //   "#0057d9",
  //   "#1e70ff",
  //   "#3399ff",
  //   "#66b2ff",
  //   "#99ccff",
  //   "#cce5ff",
  // ];
  const colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(baseColors[i % baseColors.length]); // Cycle through base colors
  }
  return colors;
};

// Function to generate a color map for entities
export const generateStackedBarColors = (entities) => {
  const baseColors = [
    "#1064bd",
    "#27a34a",
    "#562382",
    "#282beb",
    "#16f045",
    "#a554eb",
    "#f39c12",
    "#e74c3c",
  ];
  const colorMap = {};

  // Map each entity to a unique color
  entities.forEach((entity, index) => {
    colorMap[entity] = baseColors[index % baseColors.length];
  });

  return colorMap; // Returns a map: { entity1: color1, entity2: color2, ... }
};

export const ChartLegend = ({ chartData }) => {
  return (
    <div>
      {chartData.datasets.map((dataset, index) => (
        <span
          key={index}
          style={{
            margin: "0 5px",
            fontWeight: "bold",
            color: dataset.borderColor,
            fontSize: "12px",
            backgroundColor: "#f9f9f9",
          }}
        >
          ⬤ {dataset.label}
        </span>
      ))}
    </div>
  );
};

export const YAxis = ({ chartData }) => {
  const yAxisValues = chartData.datasets[0].data;
  const maxValue = Math.max(...yAxisValues);

  // Dynamically generate labels based on Chart.js tick size
  const stepSize = Math.ceil(maxValue / 4); // Ensure step size divides evenly
  const YAxisLabels = Array.from({ length: 5 }, (_, index) =>
    Math.round(maxValue - index * stepSize)
  );

  console.log("y axis labels-", YAxisLabels);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        height: "100%",
        paddingRight: "10px",
      }}
    >
      {YAxisLabels.map((value, index) => (
        <div
          key={index}
          style={{ height: "20%", fontWeight: "bold", fontSize: "12px" }}
        >
          {value}
        </div>
      ))}
    </div>
  );
};
